import React, { useEffect, useState } from 'react';
import { AddToLocalStorage, GetDataLocalStorage } from '../../../Framework/GlobalObj';
import { useLocation } from 'react-router-dom';

const ShriramPaymentPage = () => {
  // const [, setLoading] = useState(true);
  const [formData, setFormData] = useState(null);
  // const [, setShowPopup] = useState(false);
  const [, setRes] = useState({});

  const location = useLocation();
  const responseData = location.state?.responseData;
  console.log(responseData, 'response in shriram payment page');
  const globalObj = GetDataLocalStorage('globalObj');

  const response = responseData
  const premiumData = response.GenerateProposalResult.CoverDtlList.find(
    (item) => item.CoverDesc === "Total Amount"
  );
  console.log("Total Premium:", premiumData?.Premium);

  useEffect(() => {
    if (globalObj?.insurance?.providerName === 'SHRIRAM') {
      setRes(response);
      if (response?.GenerateProposalResult.ERROR_CODE === '0') {
        // Update local storage and set form data
        const applicationId = response?.GenerateProposalResult.POL_SYS_ID || null;
        const proposalNumber = response?.GenerateProposalResult?.PROPOSAL_NO || null;
        const totalPremium = globalObj.insurance.netPremium || 0;
        globalObj.profile.customer.applicationId = applicationId;
        globalObj.profile.customer.proposalNumber = proposalNumber;
        globalObj.insurance.netPremium = totalPremium;

        AddToLocalStorage('globalObj', globalObj);
        let productCode;
        const { vehicleType, vehicleCatagory } = globalObj.vehicle; // Extracting values for cleaner code
        if (vehicleType === 'Car') {
          productCode = 'MOT-PRD-001';
        } else if (vehicleType === 'Bike') {
          productCode = 'MOT-PRD-002';
        } else if (vehicleType === 'Commercial') {
          if (vehicleCatagory === 'GCV') {
            productCode = 'MOT-PRD-003';
          } else if (vehicleCatagory === 'PCV') {
            productCode = 'MOT-PRD-005';
          }
        } else {
          productCode = 'UNKNOWN_PRODUCT_CODE'; // Optional default value to handle unexpected cases
        }
        setFormData({
          createdBy: 'NiveshIns',
          paymentFrom: 'CCAVENUE',
          prodCode: productCode,
          QuoteId: applicationId,
          amount: premiumData?.Premium,
          proposalNumber: proposalNumber,
          sourceUrl: 'https://www.lmvinsurance.com/motor/payment/success',
          DbFrom: 'NOVA',
          application: 'LMVIns',
          prodName: 'MOTOR',
        });
      }
    }
  }, []);

  useEffect(() => {
    if (formData) {
      const form = document.getElementById('form');
      if (form) form.submit();
    }
  }, [formData]);

  return (
    <div>
      <form
        action="http://novaapiuat.shriramgi.com/uatnovapymt/MyDefaultCC.aspx"
        method="post"
        id="form"
      >
        <input type="hidden" name="DbFrom" value="NOVA" />
        <input type="hidden" name="createdBy" value="NiveshIns" />
        <input type="hidden" name="application" value="LMVIns" />
        <input type="hidden" name="paymentFrom" value="CCAVENUE" />
        <input type="hidden" name="prodCode" value="MOT-PRD-001" />
        <input type="hidden" name="isForWeb" value="true" />
        <input type="hidden" name="amount" value={formData?.amount} />
        <input type="hidden" name="description" value={formData?.proposalNumber} />
        <input type="hidden" name="QuoteId" value={formData?.QuoteId} />
        <input type="hidden" name="ReturnURL" value={formData?.sourceUrl} />
        <input type="hidden" name="sourceUrl" value={formData?.sourceUrl} />
        <button type="submit" className="btn btn-success pform_btn btn-fancy-right pull-right mt-10" style={{ textAlign: "center" }}>
          <i className="fa fa-arrow-circle-right"></i>
        </button>
      </form>
    </div>
  );
};

export default ShriramPaymentPage;
